import { toCaseData } from "./caseAdapter";
import { buildCaseSummary, buildReportSections } from "./reportCore";
import {
  getActiveCaseId,
  getAllCases,
  getCase,
  saveCase,
} from "./storageService";

declare global {
  interface Window {
    BankTongServices?: {
      version: string;
      toCaseData: typeof toCaseData;
      buildCaseSummary: typeof buildCaseSummary;
      buildReportSections: typeof buildReportSections;
      storageService: {
        saveCase: typeof saveCase;
        getCase: typeof getCase;
        getAllCases: typeof getAllCases;
        getActiveCaseId: typeof getActiveCaseId;
      };
    };
  }
}

const version = "bank-tong-services-2026-07-12-income-contract";

window.BankTongServices = {
  version,
  toCaseData,
  buildCaseSummary,
  buildReportSections,
  storageService: {
    saveCase,
    getCase,
    getAllCases,
    getActiveCaseId,
  },
};
